import type { AxiosInstance } from 'axios';
import axios from 'axios';
import { withAuthorization, withCookieAuth } from '@/@configs/axios';
import { Api } from '@/constants';

const makeSecureAxios = (baseURL: string): AxiosInstance => {
  return withAuthorization(axios.create({ baseURL }));
};

export const edupassClient = makeSecureAxios(Api.EdupassApi);
export const eduplayClient = makeSecureAxios(Api.EduplayApi);
export const falconClient = withCookieAuth(axios.create());
export const mediaClient = makeSecureAxios(Api.MediaUrl);
